
export enum MessageActionTypes {
    ADD_MESSAGE = 'ADD_MESSAGE',
    LIST_MESSAGES = 'LIST_MESSAGES',
    SET_MESSAGES = 'SET_MESSAGES',
    DELETE_MESSAGE = 'DELETE_MESSAGE',

  }
  